export const APP_START = 'APP_START';

export type AppStartAction = {
  type: 'APP_START';
};

export const appStartAction = (): AppStartAction => ({
  type: APP_START,
});
